import { Observable, Subscriber, concat } from "rxjs";
import { retryWhen, share, takeUntil, finalize, map, scan, throttleTime, tap } from "rxjs/operators";
import { AWRCData, AWRCObserverModel, AWRCRareStreamData, ProcessType } from "../../types";
import { errorHandler, setPubsubStream } from "../apiHelper";
import { getFactoryChangeObservable } from '../../Auth';
import { getAWRCInitialData } from "../ALCInitialDataServices/ALCInitialDataServices";
import { mergeFCORBRInToOneParam, parseAWRCData, setGroupedData } from "./AWRCHelper";
import { withLogger } from "../LogerServices";

const AWRCType = ProcessType.AWRC;

const AWRCObserver: AWRCObserverModel = {
    awrcObservable: null as Observable<AWRCData>,
};

const setAWRCStream = () => new Observable<AWRCRareStreamData>((observer: Subscriber<AWRCRareStreamData>) => {
    const close = setPubsubStream(observer, AWRCType);
    return close;
}).pipe(
    retryWhen(errors => errorHandler(errors)),
    takeUntil(getFactoryChangeObservable()),
    share()
);

const AWRCDataObservable = () => {
    AWRCObserver.awrcObservable = concat(
        withLogger(getAWRCInitialData(), AWRCType, {isInitial: true}),
        withLogger(setAWRCStream(), AWRCType)
    ).pipe(
        scan((acc, val) => Object.assign({}, acc, val), {}),
        throttleTime(1000),
        map(mergeFCORBRInToOneParam),
        map(parseAWRCData),
        map(setGroupedData),
        finalize(() => AWRCObserver.awrcObservable = null),
    )
    return AWRCObserver.awrcObservable
};

export const getAWRCDataObservable = (): Observable<AWRCData> => AWRCObserver.awrcObservable ? AWRCObserver.awrcObservable : AWRCDataObservable();